import { IItemCache } from '../IItemCacheObserver';
import { currentItemFacet } from '../../facets/ScopeFacets';
import { getItemSetKey } from '../items/getItemSetKey';
import { getItemsScope } from './getItemsScope';
import { currentItemSetControl } from '../../controls/currentItemSetControl';

/**
 * @beta
 */
export function getCurrentItemSetKey(
  itemCache: IItemCache,
  itemsScopeItemKey: string | undefined = getItemsScope(itemCache).itemsScopeItemKey
): string | undefined {
  const currentItem = itemCache.demandItemFacet(currentItemFacet, itemsScopeItemKey);

  const controlHandler = itemCache.demandItemFacet(currentItemSetControl, undefined);

  const {
    itemKey
  } = currentItemSetControl.evaluate(controlHandler)(itemCache, {
    itemKey: getItemSetKey(itemCache, {
      itemKey: currentItem && currentItem.itemKey
    }),
    itemsScopeItemKey
  });

  return itemKey;
}
